// extracted by mini-css-extract-plugin
export default {"EventDetailsActions":"Styles_EventDetailsActions__h+Gmh","SharingButtonSpacing":"Styles_SharingButtonSpacing__GigLb"};